module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ata":"Confirmed Arrival","atd":"Confirmed Departure","notRegistered":"Not registered"},"no":{"ata":"Bekreftet Ankomst","atd":"Bekreftet Avgang","notRegistered":"Ikke registrert"}}')
  delete Component.options._Ctor
}
